import cookies from 'js-cookie';

const KEY = 'phemex-auth-token';
const COOKIE_KEY = 'px_token';

export function readToken() {
  const token = localStorage.getItem(KEY);
  if (token) {
    writeTokenToCookie(token);
  }
  return token;
}

export function writeToken(token: string) {
  localStorage.setItem(KEY, token);
  writeTokenToCookie(token);
}

export function removeToken() {
  localStorage.removeItem(KEY);
  removeTokenFromCookie();
}

export function writeTokenToCookie(token) {
  cookies.set(COOKIE_KEY, token);
}
export function removeTokenFromCookie() {
  cookies.remove(COOKIE_KEY);
}
